
export default {
  name: 'OctalToHexadecimal',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "Is converting Octal to Hex possible?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The answer is yes. Both octal and hex are number systems commonly used in computing."
          }
        },
        {
          "@type": "Question",
          "name": "How do you convert Octal to Hex without Decimals?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can directly map each octal digit to its hex equivalent with a conversion table. For example, octal 6 corresponds to hex 6, and octal 7 corresponds to hex 7, and so on. Besides, for numbers over 20, you can use binary or an online tool for conversion."
          }
        },
        {
          "@type": "Question",
          "name": "What is 651.124 octal in Hex?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "The octal number 651.124 does not have a direct representation in hex because octal includes decimals, but the hex system does not. If you need to convert octal with decimals to the hex system, you would convert the integer part to hex and leave the fractional part as is."
          }
        },
        {
          "@type": "Question",
          "name": "How to convert 123 Octal to Hex?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "To convert octal 123 to hex, you would first convert it to binary and then convert the binary to hexadecimal. Octal 123 is equivalent to hex 53."
          }
        },
        {
          "@type": "Question",
          "name": "What is the main advantage of using a Hex number system over Binary, Octal, and Decimal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Hex provides a more compact representation of binary data. It uses fewer digits to represent the same amount of information. So it is easier for humans to read and work with large binary numbers."
          }
        }
      ]
    };
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        octal_number: null
      })
    }
  },
  methods: {
    OctalToHexadecimal() {
        this.form.post(`/tool/octal-to-hexadecimal`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    },
    onSample(){
        this.form.octal_number = '6543';
    },
    onReset(){
        this.form.reset();
        this.data = null;
    }
  }
}
